import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Contact from "@/pages/Contact";

export const Route = createFileRoute("/zh-cn/contact")({
  head: () => buildRouteHead("/zh-cn/contact"),
  component: Contact,
});

